export enum CompanyStatus {
  Active = "ACTIVE",
  Delete = "DELETE",
}
